<script>
import ServidorFichaFinanceira from '@/components/shared/servidor/ServidorFichaFinanceira.vue'

export default {
  extends: ServidorFichaFinanceira,
}
</script>
